import { useEffect, useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { FileDown, Mail } from "lucide-react";
import { API } from "../../config";
import { infraT } from "./infraI18n";

export const InfraMonthlyReport = ({ headers, lang = "it" }) => {
  const t = infraT(lang);
  const lg = lang === "en" ? "en" : "it";
  const [periods, setPeriods] = useState([]);
  const [recipients, setRecipients] = useState([]);
  const [upgrade, setUpgrade] = useState(null);
  const [period, setPeriod] = useState("");
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    axios.get(`${API}/admin/infra-resources/monthly-report/months`, { headers, params: { lang: lg } }).then((r) => {
      setPeriods(r.data.periods); setRecipients(r.data.recipients); setUpgrade(r.data.upgrade);
      setPeriod((p) => p || r.data.periods[0]?.period || "");
    }).catch(() => setPeriods([]));
  }, [lg]); // eslint-disable-line react-hooks/exhaustive-deps

  const download = async () => {
    setBusy(true);
    try {
      const r = await axios.get(`${API}/admin/infra-resources/monthly-report/${period}/pdf`, { headers, params: { lang: lg }, responseType: "blob" });
      const a = document.createElement("a");
      a.href = URL.createObjectURL(r.data); a.download = `${t.file}_${period}.pdf`; a.click();
    } catch { toast.error(t.dl_err); } finally { setBusy(false); }
  };
  const sendMe = async () => {
    setBusy(true);
    try {
      const r = await axios.post(`${API}/admin/infra-resources/monthly-report/${period}/send-me`, {}, { headers, params: { lang: lg } });
      r.data.sent ? toast.success(t.sent.replace("{to}", r.data.to.join(", "))) : toast.error(t.send_err);
    } catch { toast.error(t.send_err); } finally { setBusy(false); }
  };

  if (!periods.length) return null;
  const btn = "flex items-center gap-1.5 px-3 py-1.5 rounded-lg text-xs border border-gray-700 text-gray-200 hover:bg-white hover:text-black disabled:opacity-50";
  return (
    <div className="border-t border-gray-800 pt-4 flex flex-wrap items-center gap-3" data-testid="infra-monthly-report">
      <p className="text-sm text-white font-medium mr-2">{t.report}</p>
      <select value={period} onChange={(e) => setPeriod(e.target.value)} data-testid="infra-report-month"
        className="bg-[#0a0a0a] border border-gray-700 rounded-lg px-3 py-1.5 text-sm text-white">
        {[["month", t.monthly], ["quarter", t.quarterly], ["year", t.annual]].map(([kind, label]) => (
          <optgroup key={kind} label={label}>
            {periods.filter((p) => p.kind === kind).map((p) => <option key={p.period} value={p.period}>{p.label}</option>)}
          </optgroup>
        ))}
      </select>
      <button onClick={download} disabled={busy} data-testid="infra-report-download" className={btn}><FileDown size={14} /> {t.download}</button>
      <button onClick={sendMe} disabled={busy} data-testid="infra-report-send-me" className={btn}><Mail size={14} /> {t.send_me}</button>
      {upgrade && (
        <p className="text-sm text-gray-200 w-full bg-[#0a0a0a] border border-gray-800 rounded-xl px-4 py-3" data-testid="infra-upgrade-forecast">
          <b className="text-white">{t.upg}:</b> {upgrade.text}
        </p>
      )}
      <p className="text-xs text-gray-500 w-full" data-testid="infra-report-recipients">
        {t.auto} {recipients.length ? recipients.join(", ") : t.none}
      </p>
    </div>
  );
};
